<template>
  <div>
    <ValidationObserver ref="observer" tag="form" v-slot="{ valid }" @submit.prevent="valid(nextCard)">
      <!-- <form @submit.prevent="nextCard"> -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>outlined_flag</md-icon>
          </div>
          <h4 class="title">Enter SafeCore Jobsite Information</h4>
        </md-card-header>
        <md-card-content class="md-layout start-inputs">
          <md-progress-bar
            class="md-primary md-layout-item md-size-100"
            :md-value="card1amt"
          ></md-progress-bar>
          <!-- <form> -->
          <md-field class="md-layout-item md-size-100">
              <label>Select Project Type</label>
              <md-select v-model="request.project_type" name="project_type" id="project_type">
                <md-option value="gpr">GPR Project</md-option>
                <md-option value="personal">Private Utility Locate Project</md-option>
                <md-option value="811">811 Project</md-option>
              </md-select>
          </md-field>
          <ValidationProvider name="startdate" rules="required" v-slot="{ passed, failed }" class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100">
            <md-datepicker
              v-model="request.requested_start_date"
              md-immediately
              required
              :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
            >
            <slide-y-down-transition>
              <md-icon class="error date-check" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success date-check" v-show="passed">done</md-icon>
            </slide-y-down-transition>
            <label>Requested Start Date*</label>
          </md-datepicker>
          </ValidationProvider>
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100 rq-start-time" >
              <label>Requested Start Time</label>
              <md-select v-model="time.hour" name="hour" id="hour">
                <md-option value="5">5</md-option>
                <md-option value="6">6</md-option>
                <md-option value="7">7</md-option>
                <md-option value="8">8</md-option>
                <md-option value="9">9</md-option>
                <md-option value="10">10</md-option>
                <md-option value="11">11</md-option>
                <md-option value="12">12</md-option>
                <md-option value="1">1</md-option>
                <md-option value="2">2</md-option>
                <md-option value="3">3</md-option>
                <md-option value="4">4</md-option>
              </md-select>
              <md-select v-model="time.minute" name="minute" id="minute" required>
                <md-option value="00">00</md-option>
                <md-option value="30">30</md-option>
              </md-select>
              <md-select v-model="time.ap" name="ap" id="ap" required>
                <md-option value="AM">AM</md-option>
                <md-option value="PM">PM</md-option>
              </md-select>
              <!-- <slide-y-down-transition>
                <md-icon class="error select-check" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success select-check" v-show="passed">done</md-icon>
              </slide-y-down-transition> -->
          </md-field>
          <p class="sign-label">For GPR Projects only: You will receive a confirmation phone call to confirm actual start date and time based on our schedule and availability.</p>
          <ValidationProvider name="buildingtype" rules="required" v-slot="{ passed, failed }" class="md-layout-item md-size-100">
            <md-field class="ats-select" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Building Type</label>
              <md-select v-model="request.building_type" name="license" id="license" required>
                <md-option value="high rise">High Rise</md-option>
                <md-option value="hospital / health care center">Hospital / Health Care Center</md-option>
                <md-option value="university / school">University / School</md-option>
                <md-option value="office building">Office Building</md-option>
                <md-option value="parking garage">Parking Garage</md-option>
                <md-option value="warehouse">Warehouse</md-option>
                <md-option value="strip mall">Strip Mall</md-option>
                <md-option value="residence">Residence</md-option>
                <md-option value="811">811/Excavation Project</md-option>
                <md-option value="other">Other</md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error select-check" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success select-check" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
          <md-field class="md-layout-item md-size-100 ats-select">
            <label>Type of floor or wall to be scanned</label>
            <md-select v-model="request.type_to_be_scanned" name="typeofSurface" id="typeofSurface" required>
              <md-option value="slab on grade">Slab on Grade</md-option>
              <md-option value="rebar reinforced floor">Rebar reinforced floor</md-option>
              <md-option value="concrete over metal pan deck">Concrete over metal pan deck</md-option>
              <md-option value="post tension reinforced floor">Post tension reinforced floor</md-option>
              <md-option value="precast floor">Precast Floor</md-option>
              <md-option value="precast wall">Precast Wall</md-option>
              <md-option value="concrete wall">Concrete Wall</md-option>
              <md-option value="masonry wall">Masonry Wall</md-option>
              <md-option value="concrete beam">Concrete Beam</md-option>
              <md-option value="concrete column">Concrete Column</md-option>
              <md-option value="other">Other</md-option>
            </md-select>
          </md-field>
          <md-field class="md-layout-item md-size-45 ats-select md-medium-size-100 md-small-size-100" >
            <label>GPR Scan for Coring?</label>
            <md-select v-model="measurements.coring" name="license" id="license">
              <md-option :value="true">Yes</md-option>
              <md-option value="no">No</md-option>
            </md-select>
          </md-field>
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100" v-if="measurements.coring == true">
            <label>Provide sizes + quantities of cores required</label>
            <md-input v-model="request.gpr_scan_for_coring" type="text"/>
          </md-field>
          <div class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100 blank" v-else/>

          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100 ats-select" >
            <label>GPR Scan for floor sawing?</label>
            <md-select v-model="measurements.floor_sawing" name="license" id="license">
              <md-option :value="true">Yes</md-option>
              <md-option value="no">No</md-option>
            </md-select>
          </md-field>
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100" v-if="measurements.floor_sawing == true">
            <label>Provide LxWxDepth of areas to be sawcut</label>
            <md-input v-model="request.gpr_scan_for_floor_sawing" type="text"></md-input>
          </md-field>
          <div class="md-layout-item md-size-45 blank md-medium-size-100 md-small-size-100" v-else/>

          <md-field class="md-layout-item md-size-45 ats-select md-medium-size-100 md-small-size-100" >
            <label>GPR Scan for beams or columns?</label>
            <md-select v-model="measurements.beams" name="license" id="license" >
              <md-option :value="true">Yes</md-option>
              <md-option value="no">No</md-option>
            </md-select>
          </md-field>
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100" v-if="measurements.beams == true">
            <label>Provide LxWxDepth of areas to be scanned</label>
            <md-input v-model="request.gpr_scan_for_beams_or_columns" type="text"></md-input>
          </md-field>
          <div class="md-layout-item md-size-45 blank md-medium-size-100 md-small-size-100" v-else/>

          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100 ats-select" >
            <label>Provide 811 Dig #?</label>
            <md-select
              v-model="measurements.voids_ud"
              name="license"
              id="license"
            >
              <md-option :value="true">Yes</md-option>
              <md-option value="no">No</md-option>
            </md-select>
          </md-field>
          <md-field class="md-layout-item md-size-45 md-medium-size-100 md-small-size-100" v-if="measurements.voids_ud == true">
            <label>Enter 811 Dig #</label>
            <md-input
              v-model="request.gpr_scan_for_vids_utilities_or_underground_detection"
              type="text"
            ></md-input>
          </md-field>
          <div class="md-layout-item md-size-45 blank md-medium-size-100 md-small-size-100" v-else/>

          <md-field class="md-layout-item md-size-100">
            <label>Enter Additional Job Information</label>
            <md-input
              v-model="request.additional_info"
              type="text"
            ></md-input>
          </md-field>

          <md-field class="md-layout-item md-size-100">
            <label>Add one photo to your ats request</label>
            <md-file
              @change="setPhotos($event.target.files)"
              multiple
              accept="image/*"
            ></md-file>
          </md-field>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <p v-if="notValid" class="required-fields">Please fill in required fields</p>
          <md-button class="md-info" v-on:click="nextCard()">Next</md-button>
        </md-card-actions>
      </md-card>
    <!-- </form> -->
  </ValidationObserver>
  </div>
</template>
<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", required);
// import VueTimepicker from 'vue2-timepicker';

export default {
  components: {
    // VueTimepicker
  },
  props: ['request'],
  data() {
    return {
      card1amt: 5,
      notValid: false,
      time: {
        hour: '7',
        minute: '00',
        ap: 'AM'
      },
      measurements: {
        coring: false,
        beams: false,
        floor_sawing: false,
        voids_ud: false,
      }
    }
  },
  methods: {
    async nextCard() {
      console.log("validating...");
      console.log(this.request);
      console.log(this.$refs);
      const isValid = await this.$refs.observer.validate();
      console.log("validated");
      if (isValid) {
        console.log("Valid");
        this.notValid = false;
        this.$emit("next", 1);
      } else {
        console.log("Not Valid");
        this.notValid = true;
      }
    },
     setPhotos(files) {
      console.log(files)
       // this.photos = files;
       this.$emit('grabPhotos', files)
    },
  },
  watch: {
    time: function() {
      if (ap !== ''){
        var time = this.time.hour + ':' + this.time.minute + ' ' + this.time.ap
        this.$emit("setTime", time);
      }
    }
  }
}
</script>
<style lang="scss">
    .md-field {
      .select-check.md-icon {
        right: 20px;
      }
      .date-check.md-icon {
        right: 40px;
      }
    }
    .timepicker-sp {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      p {
        margin: 0;
        margin-right: 10px;
      }
    }

    .rq-start-time {
      label {
        top: -8px;
      }
      .md-select {
        input {
          text-align: center;
        }
      }
    }


</style>
